import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bb4449a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ignore-view-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "selection-bar cm-ui-mb15"
}
const _hoisted_3 = {
  key: 0,
  class: "leak-level"
}
const _hoisted_4 = {
  key: 1,
  class: "leak-level optional"
}
const _hoisted_5 = ["onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_PatchPopover = _resolveComponent("PatchPopover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SearchFilterBar, {
      style: {"padding":"16px 16px 0","background-color":"var(--cm-color-card-bg)"},
      modelValue: _ctx.queryParams,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryParams) = $event)),
      "form-columns": _ctx.filterFormColumns,
      "show-search": false,
      "popover-threshold": 2,
      onQuery: _ctx.handleQuery,
      onReset: _ctx.handleReset
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          class: "cm-ui-mb15",
          disabled: (_ctx.selectedCount ?? 0) < 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.batchCancelIgnore()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('vulnerabilityFixPage.batchCancelIgnore')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.pageAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "form-columns", "onQuery", "onReset"]),
    (_ctx.selectedCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.terminalSelected')) + " ", 1),
            _createElementVNode("a", null, _toDisplayString(_ctx.selectedCount), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('safeProtectionModule.itemsUnit')), 1)
          ]),
          _createVNode(_component_el_button, {
            class: "btn cm-ui-ml10",
            type: "text",
            disabled: _ctx.selectedCount === 0,
            onClick: _ctx.selectCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.deselect')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "table-wrapper",
      style: _normalizeStyle({ height: _ctx.viewMode === _ctx.TableViewMode.full ? 'calc(100% - 120px)' : 'calc(400px - 56px)' })
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "empty-text": _ctx.$t('common.noData'),
        ref: "tableRef",
        data: _ctx.tableData,
        "min-width": "100%",
        height: _ctx.viewMode === _ctx.TableViewMode.full ? '100%' : undefined,
        "tooltip-effect": "light",
        onSelectionChange: _ctx.handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('safeProtectionModule.patchNumber'),
            prop: "kb_number",
            width: 160
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_PatchPopover, {
                "patch-info": _ctx.patch_info,
                "warn-level": scope.row.warn_level,
                "description-fallback": _ctx.displayKbDesc(scope.row),
                "pub-date-fallback": scope.row.kb_pub_date
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "kb_number",
                    onMouseover: ($event: any) => (_ctx.getPatchInfo(scope.row )),
                    "data-test": "kb_number"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`KB${scope.row.kb_number}`), 1)
                    ]),
                    _: 2
                  }, 1032, ["onMouseover"])
                ]),
                _: 2
              }, 1032, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('safeProtectionModule.patchPubDate'),
            prop: "kb_pub_date",
            width: 160
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('safeProtectionModule.leakLevel'),
            prop: "warn_level",
            width: 180
          }, {
            default: _withCtx((scope) => [
              (scope.row.warn_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.highRisk')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.optional')), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "kb_desc",
            label: _ctx.$t('safeProtectionModule.leakDesc'),
            "min-width": 200
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_PatchPopover, {
                "patch-info": _ctx.patch_info,
                placement: "bottom",
                "warn-level": scope.row.warn_level,
                "description-fallback": _ctx.displayKbDesc(scope.row),
                "pub-date-fallback": scope.row.kb_pub_date
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "patch_text",
                    onMouseover: ($event: any) => (_ctx.getPatchInfo(scope.row ))
                  }, _toDisplayString(_ctx.displayKbDesc(scope.row)), 41, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('listColumns.operation'),
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.cancelIgnore(scope.row)),
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('baselineDashboard.cancelIgnore')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["empty-text", "data", "height", "onSelectionChange"])), [
        [_directive_loading, _ctx.isLoading],
        [_directive_load_more, _ctx.loadMoreData]
      ])
    ], 4),
    (_ctx.viewMode === _ctx.TableViewMode.full)
      ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
          key: 1,
          loading: _ctx.isLoading,
          current: _ctx.tableData.length,
          total: _ctx.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"]))
      : _createCommentVNode("", true)
  ]))
}